export const GENDER = [
  { name: "مرد", value: "male" },
  { name: "زن", value: "female" },
];

export const MESSAGE_TYPE = [
  { name: "داخل برنامه", value: "in-app" },
  { name: "پیامک", value: "sms" },
  { name: "نوتیفیکیشن", value: "push" },
];
export const MESSAGE_TEMPLATE_TYPE = [
  { name: "عمومی", value: "general" },
  { name: "پیامک", value: "sms" },
  { name: "نوتیفیکیشن", value: "push" },
  { name: "ایمیل", value: "email" },
];

export const API_URL = "https://gis.demo.kashantejarat.ir/";

export const MAP_CENTER = { lat: 32.64674557848894, lng: 51.67777329888067 };

export const LEVEL = 5;

export const LEVEL_DATA = [
  { color: "#ff090969", id: 1 },
  { color: "#ff7c0970", id: 2 },
  { color: "#fff00970", id: 3 },
  { color: "#ff09aa91", id: 4 },
  { color: "#09ffdc85", id: 5 },
  { color: "#09ffdc85", id: 6 },
  { color: "#a709ff87", id: 7 },
];

export const LEVELS = [
  { id: 1, name: "استان" },
  { id: 2, name: "شهرستان" },
  { id: 3, name: "شهر" },
  { id: 4, name: "منطقه کلان شهری" },
  { id: 5, name: "منطقه" },
  { id: 6, name: "ناحیه" },
  { id: 7, name: "محله" },
];

export const SEND_MESSAGE_METHOD = [
  { name: "داخل برنامه", value: "in-app" },
  { name: "پیامک", value: "sms" },
  { name: "نوتیفیکیشن", value: "push" },
];

export const FLEET_FREE_TYPE = [
  { title: "آزاد", id: "false" },
  { title: "همه", id: "true" },
];
export const SENDER_RECEIVER = [
  { title: "فرستنده", id: "sender" },
  { title: "گیرنده", id: "receiver" },
];
export const RATE_TYPE = {
  driver: "راننده",
  customer: "صاحب‌بار",
  company: "شرکت حمل",
};

export const OWNER_TYPES_VALUE = {
  legal: "legal",
  natural: "natural",
};

export const OWNER_TYPES_FA_VALUE = {
  legal: "حقوقی",
  natural: "حقیقی",
};

export const OWNER_TYPES = [
  { title: OWNER_TYPES_FA_VALUE.legal, id: OWNER_TYPES_VALUE.legal },
  { title: OWNER_TYPES_FA_VALUE.natural, id: OWNER_TYPES_VALUE.natural },
];

export const PERSON_TYPES_FA_VALUE = {
  legal: "حقوقی",
  natural: "حقیقی",
};

export const PERSON_TYPES = {
  shipping_company: "shipping_company",
  legal: "legal",
  natural: "natural",
};

export const PERSON_TYPES_VALUE = {
  shipping_company: "legal",
  legal: "legal",
  natural: "natural",
};

export const PERSON_TYPES_OBJ = [
  { title: "شرکت حمل", id: PERSON_TYPES.shipping_company },
  { title: "حقوقی", id: PERSON_TYPES.legal },
  { title: "حقیقی", id: PERSON_TYPES.natural },
];

export const PERSON_OWNER_TYPES_VALUE = {
  [PERSON_TYPES.legal]: null,
  [PERSON_TYPES.natural]: null,
  [PERSON_TYPES.shipping_company]: "shipping_company",
};

export const ROLE_NAMES_FA = {
  "legal-owner": "صاحب کالا",
  "shipping-manager": "شرکت حمل",
  "super-admin": "ادمین",
};

export const PAGE_TITLES = {
  "/desktop": "میزکار",
  "/waybill/newWaybill": "ثبت بارنامه جدید",
  "/waybill/NewGroupWaybill": "ثبت بارنامه گروهی",
  "/waybill/NewDraft": "ثبت حواله جدید",
  "/waybill/Draft": "لیست حواله‌ها",
  "/waybill": "لیست بارنامه‌ها",
  "/contract": "لیست قراردادها",
  "/prices": "قیمت‌ها",
  "/contract/new": "ثبت قرارداد جدید",
  "/contract/storage": "انبارها",
  "/contract/report": "گزارش قرارداد",
  "/contract/report/:id": "گزارش قرارداد",
  "/contract/:id": "ویرایش قرارداد",
  "/project/new": "ثبت پروژه جدید",
  "/project/report": "گزارش مانده پروژه",
  "/project/:id": "پروژه",
  "/project/report/:id": "گزارش مانده پروژه",
  "/project": "لیست پروژه‌ها",
  "/request/tune": "لیست آهنگ حمل پروژه‌ها",
  "/request/tune/:id": "ویرایش آهنگ پروژه",
  "/request/tune/new": "ثبت آهنگ حمل پروژه",
  "/request/new": "ثبت درخواست حمل",
  "/request": "لیست درخواست حمل",
  "/request/:id": "ویرایش درخواست",
  "/request/report": "گزارش ساز (درخواست‌های بدون قرارداد)",
  "/project/shipping-plan-new": "برنامه‌ریزی پروژه",
  "/shippingCompany": "لیست شرکت حمل و نقل",
  "/shippingCompany/report": "گزارش عملکرد شرکت حمل",
  "/LegalAndCompany": "لیست اشخاص حقوقی و شرکت ها",
  "/fleet": "لیست ناوگان",
  "/fleet/reportPast": "گزارش سوابق ناوگان",

  "/survey": "نظرسنجی",
  "/fleet/free": "گزارش ناوگان آزاد",
  "/report-generator": "گزارش‌ساز",
  "/fleet/new": "ثبت ناوگان",
  "/beneficiary": "ذینفعان",
  "/request/fleet-allocation": "تخصیص ناوگان",
  "/product": "لیست محصولات",
  "/product/group": "گروه محصول",
  "/product/packing": "نوع بسته‌بندی",
  "/product/unit": "واحد شمارشی",
  "/owner": "لیست صاحبان‌بار",
  "/owner/new": "ثبت صاحب‌‌بار جدید",
  "/owner/report": "گزارش عملکرد صاحب بار",
  "/salon": "سالن بار",
  "/salon/report": "گزارش سالن بار",
  "/driver": "لیست رانندگان",
  "/driver/new": "ثبت راننده جدید",
  "/driver/report": "گزارش عملکرد راننده",
  "/fleet/report": "گزارش عملکرد ناوگان",
  "/person": "لیست فرستندگان و گیرندگان",
  "/person/new": "ثبت فرستنده و گیرنده جدید",
  "/person/:id": "ویرایش فرستنده و گیرنده",
  "/vehicle": "لیست خودرو‌ها",
  "/financial": "مالی",
  "/financial/transaction": "تراکنش ها",
  "/financial/calculate-request": "محاسبه صورتحساب",
  "/financial/invoice": "صورتحساب ها",
  "/financial/invoice-settlement": "تسویه صورتحساب",
  "/financial/account": "حساب ها",
  "/financial/IncreaseCredit": "افزایش موجودی کیف پول",
  "/financial/ReductionCredit": "برداشت وجه از کیف پول",
  "/financial/bagInbag": "واریز وجه به حساب اشخاص",
  "/financial/paymentsGroup": "پرداخت تجمیعی",
  "/financial/settingWallet": "تنظیمات کیف پول",
  "/financial/AccountBank": "حساب های بانکی",
  "/financial/Wallet": "کیف پول سامانه",
  "/financial/payments": "پرداخت ها",
  "/vehicle/category": "نوع کامیون",
  "/vehicle/brand": "برند",
  "/vehicle/type": "نوع بارگیر",
  "/vehicle/model": "مدل خودرو",
  "/vehicle/refueling": "سوخت‌گیری",
  "/user": "لیست کاربران",
  "/super-app": "مدیریت سوپر اپ",
  "/role": "لیست نقش‌ها",
  "/event": "رویداد‌ها",
  "/settings": "تنظیمات",
  "/contact-us": "شکایات",
  "/request/salon": "لیست سالن بار",
  "/fleet/group": "گروه ناوگان",
  "/super-app/section/item": "آیتم‌ها",
  "/super-app/section": "بخش‌‌ها",
  "/messages": "پیام‌ها",
  "/reports/requests-by-provinces": "گزارش جامع کشوری",
  "/request/requests-by-cities": "گزارش فراوانی درخواست شهر",
  "/messages/my": "پیام‌های من",
  "/messages/alerts": "هشدار‌ها",
  "/messages/send": "ارسال پیام",
  "/messages/templates": "الگو‌های پیام‌",
  "/monitoring": "مانیتورینگ",
  "/reports/driver-invoice-report": "گزارش صورتحساب راننده",
};

export { INPUT_TYPE } from "./inputTypes";
